import { FIELD_ID_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { useWatch } from "react-hook-form";

export const useWatchIsNew = (roleFormKey: RoleFormKey) =>
  useWatch({
    name: `${roleFormKey}.${FIELD_ID_KEY}`,
    compute: (value) => !value
  });
